import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { GetOrganizationOptions, Org } from '@nx-frontend/shared/types';

export async function getOrganizations({ userId, onlyOwned = false }: GetOrganizationOptions): Promise<Org[]> {
  let organizations: Org[] = [];

  try {
    const response = await axiosClient.get<Org[]>(`${generalEnv.orgServiceUrl}/v1/orgs`, {
      headers: {
        Authorization: `internal ${userId}:auto`,
      },
      params: {
        onlyOwned: String(onlyOwned),
      },
    });
    organizations = response.data.map((org) => ({
      ...org,
      sub: org.sub.toLocaleLowerCase(),
    }));
  } catch (err) {
    console.error(`getOrganizations error: ${err}`);
  }

  return organizations;
}
